import { render, staticRenderFns } from "./ListItemDetail.vue?vue&type=template&id=39c25ccd&scoped=true&"
import script from "./ListItemDetail.vue?vue&type=script&lang=js&"
export * from "./ListItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c25ccd",
  null
  
)

export default component.exports